<template>
  <div class="buy-car-content" v-show="showState">
    <div class="buy-car-title">购物车商品</div>
    <div class="goods-list">
      <template  v-for="(item,index) in dataList">
        <div :key="index" v-if="item.isSuit" class="suit-item">
          <div class="promotion-item">
            <div class="promotion-type">套装</div>
            <div class="good-msg">
              <p class="goods-price">￥{{item.zhMoneyCount}} x {{item.BuyCount}}</p>
              <p class="del-btn" @click="delGoods(index)">删除</p>
            </div>
          </div>
          <div :key="index" v-for="(suit,index) in item.PackageGoodsList" class="goods-item">
            <img :src="downloadUrl+suit.ShowImg" :onerror="defaultImg" />
            <div class="goods-name" :title="suit.Name">{{suit.Name}}</div>
            <div class="good-msg">
              <p>
                <span class="goods-price">￥{{suit.ShopPrice}}x{{suit.Number}}</span>
              </p>
            </div>
          </div>
        </div>
        <div :key="index + 1" class="goods-item" v-else>
          <img :src="downloadUrl+item.ShowImg" alt :onerror="defaultImg" />
          <div class="goods-name" :title="item.Name">{{item.Name}}</div>
          <div class="good-msg">
            <p>
              <span class="goods-price">￥{{item.zhMoney}}×{{item.BuyCount}}</span>
            </p>
            <p class="del-btn" @click="delGoods(index)" v-if="permission.edit">删除</p>
          </div>
        </div>
      </template>
    </div>
    <div class="car-msg">
      <span>共{{checkedNum}}件商品</span>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <span>共计￥{{checkedPrice}}</span>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-button class="btn-primary" size="mini" @click="gotoBuyCar">去购物车</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: ["showState"],
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      tableDataLength: 0,
      nowHgIndex: -1, // 当前执行换购商品的索引
      nowHgChosen: false,
      hgList: [], // 这个是动态变的
      showHg: false,
      showPromotion: false, // 促销
      dataList: [], // 商品和套装列表
      checkedList: [], // 选中的商品和套装列表
      checkedNum: 0, // 选中的商品和套装的数量
      checkedPrice: 0, // 选中的商品和套装的折后总价
      checkedOriginalPrice: 0, // 选中的商品和套装的原价
      downloadUrl: this.$util.QN_URL_BASE,
      noData: false,
      checkAll: false,
      promotionData: {},
      promotionIndex: -1,
      promotionLayer: {}, // 促销弹窗数据
      permission: {}
    };
  },
  methods: {
    // 跳转购物车
    gotoBuyCar() {
      this.$router.push("/shop/buycar");
    },
    // 读取购物车数据计算数量
    getTableData() {
      this.$util
        .axiosGet({
          url: "/api/MallShoppingCart/GetShoppingCartGoodsList",
          data: {
            UserId: this.userMsg.EmployeeId
          },
          hideLoading: true
        })
        .then(res => {
          let data = res.data;
          if (data.GoodsList.length == 0 && data.PackageList.length == 0) {
            this.noData = true;
            this.dataList = [];
            this.tableDataLength = 0;
            this.countData();
            return;
          }
          // 定义各种状态标识
          for (let i = 0; i < data.GoodsList.length; i++) {
            data.GoodsList[i].checked = true; // 是否选中
            data.GoodsList[i].isSuit = false; // 是否为套装
            data.GoodsList[i].canMs = false; // 是否可以买送
            data.GoodsList[i].msNum = 1; // 满送数量
            data.GoodsList[i].canHg = false; // 是否可以换购
            data.GoodsList[i].hgGoods = {}; // 选中的换购商品
            data.GoodsList[i].zhMoney = data.GoodsList[i].ShopPrice; // 单品促销完的单价(默认原价)
            data.GoodsList[i].zhMoneyCount = data.GoodsList[i].ShopPrice; // 买这个商品的总价（默认单价*1）
            data.GoodsList[i].originalCount = data.GoodsList[i].ShopPrice;
          }
          for (let j = 0; j < data.PackageList.length; j++) {
            data.PackageList[j].checked = true;
            data.PackageList[j].isSuit = true; // 是否为套装
            data.PackageList[j].zhMoneyCount = 0;
            data.PackageList[j].zhMoneySuit = 0;
            data.PackageList[j].originalCount = 0;
            data.PackageList[j].hgGoods = {}; // 选中的换购商品
          }
          this.dataList = [...data.GoodsList, ...data.PackageList];
          this.tableDataLength = this.dataList.length;
          this.countData();
          let timestamp = new Date().getTime();
          this.$store.commit("updateRefreshShopCar", timestamp);
        });
    },
    countData() {
      let _hgList = this.hgList;
      let _data = this.dataList;
      for (let i = 0; i < _data.length; i++) {
        // 套装
        if (_data[i].isSuit) {
          _data[i].zhMoneyCount = 0;
          _data[i].originalCount = 0;
          _data[i].zhMoneySuit = 0;
          let _Suit = _data[i].PackageGoodsList;
          for (let s = 0; s < _Suit.length; s++) {
            _Suit[s].zhMoney = _Suit[s].ShopPrice - _Suit[s].Discount;
            _data[i].zhMoneySuit += _Suit[s].zhMoney * _Suit[s].Number;
            _data[i].zhMoneyCount +=
              _Suit[s].zhMoney * _Suit[s].Number * _data[i].BuyCount;
            _data[i].originalCount +=
              _Suit[s].ShopPrice * _Suit[s].Number * _data[i].BuyCount;
          }
        }
        // 单品
        else {
          _data[i].zhMoneyCount = _data[i].ShopPrice * _data[i].BuyCount;
          _data[i].originalCount = _data[i].ShopPrice * _data[i].BuyCount;
          // 判断是否达到换购条件
          if (_data[i].ExchangeBuyPromotion) {
            if (
              _data[i].zhMoneyCount > _data[i].ExchangeBuyPromotion.LimitMoney
            ) {
              _data[i].canHg = true;
            } else {
              _data[i].canHg = false;
              _data[i].hgGoods = {};
              for (let i = 0; i < _hgList.length; i++) {
                _hgList[i].checked = false;
              }
            }
          }
          // 判断是否达到满送条件
          if (_data[i].BuyGivePromotion) {
            let _BuyCount1 = _data[i].BuyCount;
            let _BuyCount2 = _data[i].BuyGivePromotion.BuyCount;
            setTimeout(() => {
              if (_BuyCount1 >= _BuyCount2) {
                _data[i].canMs = true;
                _data[i].msNum =
                  parseInt(
                    _data[i].BuyCount / _data[i].BuyGivePromotion.BuyCount
                  ) * _data[i].BuyGivePromotion.SendCount;
              } else {
                _data[i].canMs = false;
              }
            });
          }
          // 单品促销 lv1
          if (_data[i].SinglePromotion) {
            _data[i].zhMoney = this.SinglePromotionHandle(
              _data[i].SinglePromotion,
              _data[i].ShopPrice
            );
            _data[i].zhMoneyCount = _data[i].zhMoney * _data[i].BuyCount;
          }
          // 换购 lv2
          if (_data[i].hgGoods.ShopPrice) {
            _data[i].zhMoneyCount =
              _data[i].zhMoneyCount + _data[i].ExchangeBuyPromotion.AddMoney;
            _data[i].originalCount =
              _data[i].originalCount + _data[i].ExchangeBuyPromotion.AddMoney;
          }
          // 满减优惠 lv3
          if (_data[i].FullDiscountPromotion) {
            if (
              _data[i].zhMoneyCount >=
              _data[i].FullDiscountPromotion.LimitMoney3
            ) {
              _data[i].zhMoneyCount =
                _data[i].zhMoneyCount -
                _data[i].FullDiscountPromotion.CutMoney3;
            } else if (
              _data[i].zhMoneyCount >=
              _data[i].FullDiscountPromotion.LimitMoney2
            ) {
              _data[i].zhMoneyCount =
                _data[i].zhMoneyCount -
                _data[i].FullDiscountPromotion.CutMoney2;
            } else if (
              _data[i].zhMoneyCount >=
              _data[i].FullDiscountPromotion.LimitMoney1
            ) {
              _data[i].zhMoneyCount =
                _data[i].zhMoneyCount -
                _data[i].FullDiscountPromotion.CutMoney1;
            }
          }
        }
      }
      let _checkedList = [];
      let _checkedNum = 0;
      let _checkedPrice = 0;
      let _checkedOriginalPrice = 0;
      let _checkAll = true;
      for (let n = 0; n < _data.length; n++) {
        if (_data[n].State == 5) {
          if (_data[n].checked) {
            _checkedNum += _data[n].BuyCount;
            _checkedPrice += _data[n].zhMoneyCount;
            _checkedOriginalPrice += _data[n].originalCount;
            _checkedList.push(_data[n]);
          } else {
            _checkAll = false;
          }
        }
      }
      this.checkAll = _checkAll;
      this.checkedList = _checkedList;
      this.checkedNum = _checkedNum;
      this.checkedPrice = this.$util.num2Float(_checkedPrice);
      this.checkedOriginalPrice = this.$util.num2Float(_checkedOriginalPrice);
      this.$emit("getNum", _checkedNum);
    },
    // 单品促销处理
    SinglePromotionHandle(Promotion, price) {
      if (Promotion.DiscountType == 0) {
        return price * Promotion.DiscountValue * 0.1;
      } else if (Promotion.DiscountType == 1) {
        return price - Promotion.DiscountValue;
      } else if (Promotion.DiscountType == 2) {
        return Promotion.DiscountValue;
      }
    },
    // 删除
    // 商品从购物车删除
    delGoods(index) {
      let that = this;
      let target = that.dataList[index];
      let shoppingCartGoodsType = 5;
      let ShoppingCartGoodsId = "";
      if (target.isSuit) {
        ShoppingCartGoodsId = target.PackagePromotionId;
        shoppingCartGoodsType = 10;
      } else {
        ShoppingCartGoodsId = target.ShoppingCartGoodsId;
      }
      that.$util
        .axiosPost({
          url: "/api/MallShoppingCart/RemoveShoppingCartGoods",
          data: {
            ShoppingCartGoodsId: ShoppingCartGoodsId,
            ShoppingCartGoodsType: shoppingCartGoodsType,
            UserId: that.userMsg.EmployeeId
          }
        })
        .then(() => {
          that.dataList.splice(index, 1);
          if (!that.dataList[0]) {
            that.noData = true;
          }
          that.countData();
        });
    }
  }
};
</script>
<style lang="less" scoped>
.suit-count-money {
  padding-right: 30px;
  text-align: right;
  span {
    margin-left: 20px;
  }
}
.suit-item {
  border: 1px solid @border1Color;
  padding: 5px;
}
.promotion-item {
  display: flex;
  margin-right: 20px;
  padding-bottom: 10px;
}
.promotion-type {
  background: red;
  color: white;
  width: 50px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-right: 150px;
}
.del-btn {
  cursor: pointer;
  color: @theme;
}
.goods-list {
  max-height: 375px;
  overflow-y: auto;
}
.car-msg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  padding: 0 10px;
  line-height: 40px;
}
.goods-price {
  display: inline-block;
  font-weight: bold;
  margin-bottom: 5px;
}
.goods-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  padding-bottom: 5px;
  border-bottom: 1px dashed @border3Color;
  img {
    border: 1px solid @border3Color;
    margin-right: 10px;
    width: 50px;
    height: 50px;
  }
}
.goods-name {
  width: 150px;
  -webkit-line-clamp: 3;
}
.buy-car-title {
  font-size: @font-xs;
  font-weight: bold;
  padding-bottom: 10px;
}
.buy-car-content {
  position: absolute;
  left: 0;
  top: 100px;
  transform: translate(-100%, 0);
  width: 350px;
  height: 450px;
  background: white;
  border: 1px solid @border3Color;
  padding: 10px;
  text-align: left;
  z-index: 11;
}
.toolbar {
  position: fixed;
  top: 100px;
  right: 0;
  bottom: 38px;
  width: 36px;
  height: 100%;
  background: #eee;
  text-align: center;
  z-index: 99;
}
.dotted {
  height: 10px;
  border-top: 1px dotted black;
}
.buy-car-ctn {
  margin-top: 300px;
  cursor: pointer;
  padding-bottom: 5px;
  &:hover {
    background: white;
  }
}
.buy-car {
  width: 16px;
  margin: 0 auto;
  i {
    font-size: 18px;
  }
}
.goods-num {
  color: white;
  width: 24px;
  height: 24px;
  line-height: 24px;
  background: @theme;
  border-radius: 50%;
  margin: 10px auto;
}
.back-top {
  cursor: pointer;
  position: absolute;
  bottom: 150px;
  left: 5px;
  font-size: 30px;
}
</style>
